// extracted by mini-css-extract-plugin
module.exports = {"checkBox":"Checkbox_checkBox__imxqX","input":"Checkbox_input__3orzk","icon":"Checkbox_icon__koGEI","text":"Checkbox_text__2DLEV"};